import { SET_PROPERTY_FIELDS } from '../../types';
import { updateNetApprovedValue, updateValueGrossBook } from './properties';

export const updateValuation = (event) => async(dispatch, getState) => {
    const { name, value } = event.target;
    console.debug({
        name,
        value
    });

    try {
        const { properties: { propertyFields } } = getState();

        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: {
                ...propertyFields,
                [name]: value
            }
        });
    }
    catch (error) {
        throw new Error('Valuation: ' + error.message);
    }
    finally {
    //	POST UPDATE
        switch (name) {
            case 'value_gross_approved':
                dispatch(updateNetApprovedValue());
                break;
            case 'value_gross_book':
                dispatch(updateValueGrossBook());
                break;
            case 'participation_log':
                await dispatch(updateNetApprovedValue());
                dispatch(updateValueGrossBook());
                break;
            default:
                break;
        }
    }
};